import { CalendarCheck, ClipboardCheck, Phone, Truck } from "lucide-react";
import { PHONE } from "./data";
import { Eyebrow, Reveal } from "./Reveal";

const STEPS = [
  { icon: Phone, t: "Call or request", d: `Ring ${PHONE} or send the short form below.` },
  { icon: ClipboardCheck, t: "Free onsite quote", d: "We look at the load and give you an upfront price. No obligation." },
  { icon: Truck, t: "Gone, same day", d: "Say yes and we haul it away, often the very same day." },
];

export const HowItWorks = () => (
  <section data-testid="why-us-section" className="relative bg-[#0D0D0B] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <div className="grid gap-5 lg:grid-cols-2">
        <Reveal>
          <div data-testid="why-us-card-upfront" className="relative h-full overflow-hidden rounded-3xl bg-[#FFB000] p-8 text-[#0D0D0B] sm:p-12">
            <ClipboardCheck className="h-10 w-10" strokeWidth={2.25} />
            <h3 className="font-display mt-10 text-6xl uppercase leading-[0.9] sm:text-8xl">Free<br />Onsite<br />Quote</h3>
            <p className="mt-6 max-w-sm text-base font-semibold sm:text-lg">You see the price before we touch a thing. Upfront, honest, no hidden fees.</p>
            <span className="font-display pointer-events-none absolute -bottom-10 -right-4 text-[14rem] leading-none text-[#0D0D0B]/10">$0</span>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div data-testid="why-us-card-sameday" className="relative h-full overflow-hidden rounded-3xl border border-white/15 bg-[#191915] p-8 text-[#F2EEE6] sm:p-12">
            <CalendarCheck className="h-10 w-10 text-[#FFB000]" strokeWidth={2.25} />
            <h3 className="font-display mt-10 text-6xl uppercase leading-[0.9] sm:text-8xl">Same<br />Day<br /><span className="text-[#FFB000]">Pickup</span></h3>
            <p className="mt-6 max-w-sm text-base text-[#d6d2c8] sm:text-lg">Need it gone today? Call early and we'll do our best to get a crew out to you the same day.</p>
          </div>
        </Reveal>
      </div>
      <div className="mt-20">
        <Reveal><Eyebrow>How it works</Eyebrow></Reveal>
        <div className="mt-8 grid gap-px overflow-hidden rounded-3xl border border-white/10 bg-white/10 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <Reveal key={s.t} delay={i * 0.1} className="h-full">
              <div className="group h-full bg-[#0D0D0B] p-8 transition-colors duration-500 hover:bg-[#15150f]">
                <div className="flex items-center justify-between">
                  <span className="font-display text-6xl text-[#FFB000]">0{i + 1}</span>
                  <s.icon className="h-7 w-7 text-[#F2EEE6] transition-transform duration-500 group-hover:-translate-y-1" />
                </div>
                <h4 className="mt-6 text-2xl font-bold text-[#F2EEE6]">{s.t}</h4>
                <p className="mt-2 text-[#bdb9af]">{s.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
